import type { ProviderId } from "@versatile-credit-apply/omni-apply-client"
import {
  useProviderOffers,
  type ProviderOffer,
} from "@versatile-credit-apply/sdk"
import { type ComputedRef } from "vue"

export const useRetailProviderOffers = (): ComputedRef<ProviderOffer[]> => {
  const supportedProviders: Set<ProviderId> = new Set(["synchrony"])

  return useProviderOffers(supportedProviders)
}
